export enum EProductClassification {
  OverTheCounter = 'BEBAS (HIJAU)',
  Psychotropic = 'PSIKOTROPIKA',
  PrescriptionOnly = 'KERAS (MERAH)',
  NonDot = 'NON DOT',
  Limited = 'TERBATAS (BIRU)',
  Narcotic = 'NARKOTIKA',
  Unknown = 'TIDAK DIKETAHUI',
}
